import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import RaisedButton from 'material-ui/RaisedButton';
import { TableRow, TableRowColumn } from 'material-ui/Table';

import styles from 'styles';

class PortsRow extends React.Component {
    UNSAFE_componentWillReceiveProps({ item }) {
        this.setState({
            item,
        });
    }

    render() {
        const { item: { changes, _id, name, unLoCode, parent, country }} = this.props;

        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { name }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { unLoCode }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { country && country.name ? country.name : '' }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { parent && parent.name ? parent.name : ''  }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    {
                        changes && changes > 0
                        ?
                            <RaisedButton
                                label='Approve changes'
                                primary
                                containerElement={<Link to={`/regions/ports/approve/${_id}`} />}
                            />
                            :
                            <RaisedButton
                                label='Edit'
                                primary
                                containerElement={<Link to={`/regions/ports/${_id}`} />}
                            />
                    }

                </TableRowColumn>

            </TableRow>
        );
    }
}

PortsRow.propTypes = {
    item: PropTypes.object,
};

PortsRow.defaultProps = {
    item: {},
};

export default PortsRow;



// WEBPACK FOOTER //
// ./app/components/Regions/Ports/Row.jsx